const doc = [({"en":({"js":({"admin":({"plans":({"table":({"membership_period":"Membership period"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;